<div>
  <h4 class="fw-bold mt-1 mb-2">Asistencia por partes</h4>

  <div class="info-container mb-3">
    <h4 class="fw-bold mb-2">{{ attendantFullName }}</h4>
    <p class="mb-0 text-muted">
      <strong>Sesión:</strong> {{ eventAndSessionData?.sessionName }}
    </p>
    <p class="mb-0 text-muted">
      <strong>Localizador:</strong> {{ eventAndSessionData?.locatorId }}
    </p>
    <p class="mb-0 text-muted">
      <strong>Total de partes:</strong> {{ totalPartsNumber }}
    </p>
    <p class="mb-0 text-muted">
      <strong>Evento:</strong> {{ eventAndSessionData?.eventName }}
    </p>
  </div>

  <div class="table-responsive mt-md-2 mt-sm-0">
    <table class="table table-md t-elevated-shadow-cap">
      <thead>
        <tr>
          <th scope="col">Parte</th>
          <th scope="col">Fecha de asistencia</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="
            let partNumber of [].constructor(totalPartsNumber);
            let i = index
          "
          [ngClass]="{
            'w-attendance': hasAttendance(i + 1),
            'no-attendance': !hasAttendance(i + 1)
          }">
          <td>{{ i + 1 }}</td>
          <td class="d-flex justify-content-between align-items-center">
            <span>
              {{
                getAttendanceDateForPart(i + 1) || "Sin registro de asistencia"
              }}
            </span>

            <input
              *ngIf="!hasAttendance(i + 1) && canShowControls"
              class="ms-4 form-check-input"
              type="checkbox"
              class="ms-3"
              [checked]="isPartSelected(i + 1)"
              (change)="onTogglePart(i + 1)" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="d-flex justify-content-center mt-4">
    <div class="col-10 d-flex flex-column gap-3">
      <button
        type="button"
        class="btn btn-primario"
        [disabled]="!selectedParts.length"
        (click)="registerMissingAttendances()">
        <span>Registrar asistencia</span>
      </button>

      <button type="button" class="btn btn-secondary-cap" (click)="onClose()">
        <span> Cerrar </span>
      </button>
    </div>
  </div>
</div>
